// This import loads the firebase namespace along with all its type information.
import PublicPlaylist from './public-playlist-model'

export async function load_publicPlaylists(): Promise<PublicPlaylist[]> {
  throw 'Not implemented'
}

export async function delete_publicPlaylist(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_publicPlaylist(): Promise<PublicPlaylist> {
  throw 'Not implemented'
}
